import * as React from "react";

const DirectoryLedIcon = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={50}
		height={50}
		viewBox="0 0 50 50"
		xmlSpace="preserve"
		{...props}
	>
		<g />
		<g
			fill="none"
			stroke={props.color}
			strokeWidth={1.25}
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeMiterlimit={10}
		>
			<path d="M11.281 38.719A19.34 19.34 0 0 1 5.598 25a19.34 19.34 0 0 1 5.683-13.719A19.339 19.339 0 0 1 25 5.598m13.719 5.683A19.34 19.34 0 0 1 44.402 25c0 5.357-2.172 10.208-5.683 13.719S30.358 44.402 25 44.402" />
			<path d="M20.652 1.25 25 5.598l-4.157 4.157m8.505 38.995L25 44.401l4.157-4.157" />
		</g>
		<path
			fill={props.color}
			d="M25 14.066c3.696 0 5.899.847 6.477 1.329-.578.482-2.781 1.329-6.477 1.329-3.695 0-5.899-.847-6.476-1.329.578-.482 2.781-1.329 6.476-1.329m0-1.25c-4.322 0-7.826 1.155-7.826 2.579 0 1.424 3.504 2.579 7.826 2.579s7.827-1.155 7.827-2.579c0-1.425-3.504-2.579-7.827-2.579z"
		/>
		<path
			fill={props.color}
			d="M29.697 19.103c-1.308.324-2.934.516-4.697.516s-3.389-.192-4.697-.516c-1.9-.47-3.13-1.22-3.13-2.063v3.272c0 1.425 3.504 2.579 7.826 2.579s7.827-1.155 7.827-2.579V17.04c0 .844-1.229 1.593-3.13 2.063z"
		/>
		<path
			fill={props.color}
			d="M29.697 24.021c-1.308.324-2.934.516-4.697.516s-3.389-.192-4.697-.516c-1.9-.47-3.13-1.22-3.13-2.063v3.272c0 1.425 3.504 2.579 7.826 2.579s7.827-1.155 7.827-2.579v-3.272c0 .844-1.229 1.593-3.13 2.063z"
		/>
		<path
			fill="none"
			stroke={props.color}
			strokeWidth={1.25}
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeMiterlimit={10}
			d="M25 27.809v4.186m7.827 0v-1.772H17.174v1.772m.977 2.259a.977.977 0 0 1-.977.976.977.977 0 0 1-.977-.976.977.977 0 0 1 1.954 0z"
		/>
		<path
			fill="none"
			stroke={props.color}
			strokeWidth={1.25}
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeMiterlimit={10}
			d="M19.128 37.184a1.954 1.954 0 0 0-3.908 0m10.757-2.93a.977.977 0 0 1-.977.976.977.977 0 0 1-.977-.976.977.977 0 0 1 1.954 0z"
		/>
		<path
			fill="none"
			stroke={props.color}
			strokeWidth={1.25}
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeMiterlimit={10}
			d="M26.954 37.184a1.954 1.954 0 0 0-3.908 0m10.757-2.93a.977.977 0 0 1-.976.976.977.977 0 0 1-.977-.976.977.977 0 0 1 1.953 0z"
		/>
		<path
			fill="none"
			stroke={props.color}
			strokeWidth={1.25}
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeMiterlimit={10}
			d="M34.78 37.184a1.954 1.954 0 1 0-3.908 0"
		/>
	</svg>
);

export default DirectoryLedIcon;

